import { createContext, type ReactNode, useContext } from 'react'
import type { CamelClient } from './types'

const CamelClientContext = createContext<CamelClient | undefined>(undefined)

export type CamelApiProviderProps = {
  client: CamelClient
  children: ReactNode
}

export const CamelApiProvider = ({ client, children }: CamelApiProviderProps) => (
  <CamelClientContext.Provider value={client}>{children}</CamelClientContext.Provider>
)

export const useCamelClient = (): CamelClient => {
  const client = useContext(CamelClientContext)
  if (!client) throw new Error('useCamelClient requires a CamelApiProvider at the host root')
  return client
}
